import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface ChatMessage {
  sender: 'ai' | 'user';
  text: string;
  time: string;
  actionButton?: {
    label: string;
    route: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class AiChatService {
  private isChatOpenSubject = new BehaviorSubject<boolean>(false);
  isChatOpen$: Observable<boolean> = this.isChatOpenSubject.asObservable();

  private messagesSubject = new BehaviorSubject<ChatMessage[]>([]);
  messages$: Observable<ChatMessage[]> = this.messagesSubject.asObservable();

  constructor() {
    this.initializeChat();
  }

  private initializeChat(): void {
    const initialMessage: ChatMessage = {
      sender: 'ai',
      text: 'Olá! Eu sou a Trace Fornecedores, sua assistente de análise. Posso te ajudar a verificar a conformidade e o histórico dos seus fornecedores. Como posso ajudar hoje?',
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    this.messagesSubject.next([initialMessage]);
  }

  toggleChat(open?: boolean): void {
    const currentState = this.isChatOpenSubject.value;
    this.isChatOpenSubject.next(open !== undefined ? open : !currentState);
  }

  getMessages(): ChatMessage[] {
    return this.messagesSubject.value;
  }

  setMessages(messages: ChatMessage[]): void {
    this.messagesSubject.next(messages);
  }

  addMessage(message: ChatMessage): void {
    const currentMessages = this.messagesSubject.value;
    this.messagesSubject.next([...currentMessages, message]);
  }

  clearChat(): void {
    this.initializeChat();
  }
}